<template>
  <b-row>
    <b-col :cols="labelCols ? labelCols : 2" class="checkbox-label">
      <label :for="id">
        {{ label }}
      </label>
    </b-col>
    <b-col :cols="cols">
      <b-form-checkbox
        :disabled="disabled"
        :name="id"
        :id="id"
        :checked="value"
        v-on:input="$emit('input', $event)"
        :value="true"
        :unchecked-value="false"
      >
      </b-form-checkbox>
    </b-col>
  </b-row>
</template>

<script>
export default {
  name: "filter-checkbox",
  props: ["cols", "value", "label", "id", "disabled", "labelCols"]
};
</script>

<style scoped>
  .custom-checkbox.custom-control-inline {
    padding-top: 10px;
  }
</style>
